import { lazy, Suspense } from "react";

import "./LandingPage.css";

import LoadingSpinner from "../_components/loading-spinner/LoadingSpinner";

const Hero = lazy(() => import("./hero/Hero"));
const MeetProfessional = lazy(() =>import("./meet-professional/MeetProfessional"));
const CanHelpWith = lazy(() => import("./can-help-with/CanHelpWith"));
const Methodology = lazy(() => import("./methodology/Methodology"));
const ServiceInfo = lazy(() => import("./services-info/ServiceInfo"));
const HowItWorks = lazy(() => import("./how-it-works/HowItWorks"));
const Affiliates = lazy(() => import("./affiliates/Affiliates"));

const LandingPage = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <main className="LandingPage">
        <Hero />
        <MeetProfessional />
        <CanHelpWith />
        <Methodology />
        <ServiceInfo />
        <HowItWorks />
        <Affiliates />
      </main>
    </Suspense>
  );
};

export default LandingPage;
